import InputTypesEnum from '../../../../Enums/InputTypesEnum';
import ServiceTypeEnum from '../../../../Enums/ServiceTypeEnum';
import ValidityHelper from '../../../../Helpers/ValidityHelper';
import selectHelper from '../../../../Helpers/selectHelper';
import {
  specialLocationsOptionsArray,
  locationTypeOptionsArray,
  reportingRequirementsArray,
  locationListSourceArray,
  prePostPhoneCallArray,
  timeConstraintsMaxLength,
} from './SharedConstants';

const inPersonPages = [
  {
    label: 'Fieldwork Requirements',
    hide: (item) => item.TypeCode != ServiceTypeEnum.InPerson,
    fields: [
      {
        fieldName: 'InteractionRequired',
        label: 'Is Interaction Required?',
        className: 'col-12',
        type: InputTypesEnum.Bool,
      },
      {
        fieldName: 'ProductOrServiceInquiry',
        label: 'Product or Service Inquiry?',
        className: 'col-12',
        type: InputTypesEnum.Text,
      },
      {
        fieldName: 'TimeConstraints',
        label: 'Visit Time Constraints (days/hours/etc)',
        className: 'col-12',
        type: InputTypesEnum.Text,
        maxLength: timeConstraintsMaxLength,
      },
      {
        fieldName: 'MaxDeliveryAfterShop',
        label: 'Time to Deliver Evaluation to Client',
        className: 'col-12',
        type: InputTypesEnum.MaxDeliveryAfterShop,
        validityChecker: ValidityHelper.emptyValidityChecker,
      },
      {
        fieldName: 'SpecialLocations',
        label: 'Select Special Locations if Applicable',
        className: 'col-12',
        type: InputTypesEnum.MultiChoice,
        selectvalues: specialLocationsOptionsArray,
      },
      {
        fieldName: 'LocationType',
        label: 'Location Type (select all that apply)',
        className: 'col-12',
        type: InputTypesEnum.MultiChoice,
        selectvalues: locationTypeOptionsArray,
      },
      {
        fieldName: 'LocationTypeDetails',
        label: 'Location Type Details',
        className: 'col-12',
        type: InputTypesEnum.TextBox,
        hide: (item) => !item.LocationType || !item.LocationType.includes('Other'),
      },
      {
        fieldName: 'LocationListSource',
        label: 'Location List Source',
        className: 'col-12',
        type: InputTypesEnum.Select,
        selectvalues: selectHelper.generateSelectValues(locationListSourceArray.map((l) => l.label)),
      },
    ],
  },
  {
    label: 'Reporting Requirements',
    hide: (item) => item.TypeCode != ServiceTypeEnum.InPerson,
    fields: [
      {
        fieldName: 'ReportingRequirements',
        label: 'Reporting Requirements',
        className: 'col-12',
        type: InputTypesEnum.MultiChoice,
        selectvalues: reportingRequirementsArray,
      },
      {
        fieldName: 'DetailedReportingRequirements',
        label: 'Detailed Reporting Requirements',
        className: 'col-12',
        type: InputTypesEnum.TextBox,
        hide: (item) => !item.ReportingRequirements || !item.ReportingRequirements.includes('Other'),
      },
    ],
  },
  {
    label: 'Evaluation Duration',
    hide: (item) => item.TypeCode != ServiceTypeEnum.InPerson,
    fields: [
      {
        fieldName: 'EvaluationDuration',
        label: 'Evaluation Duration (DD:HH:MM)',
        className: 'col-12',
        type: InputTypesEnum.IntToDateInputElement,
      },
    ],
  },
  {
    label: 'Questionnaire',
    hide: (item) => item.TypeCode != ServiceTypeEnum.InPerson,
    fields: [
      {
        fieldName: 'NumClosedQuestions',
        label: 'No. Closed Questions',
        className: 'col-12',
        type: InputTypesEnum.Number,
      },
      {
        fieldName: 'NumOpenQuestions',
        label: 'No. Simple Text Questions',
        className: 'col-12',
        type: InputTypesEnum.Number,
      },
      {
        fieldName: 'NumNarrativeQuestions',
        label: 'No. Narrative Questions',
        className: 'col-12',
        type: InputTypesEnum.Number,
      },
      {
        fieldName: 'QuestionnaireProvided',
        label: 'Questionnaire Provided by Client?',
        className: 'col-12',
        type: InputTypesEnum.Bool,
      },
      {
        fieldName: 'TranslationProvided',
        label: 'Translation of Questionnaire Provided by Client?',
        className: 'col-12',
        type: InputTypesEnum.Bool,
      },
      {
        fieldName: 'DataCaptureMethodCode',
        label: 'Data Capture Method',
        className: 'col-6',
        type: InputTypesEnum.CommonDataCaptureMethodLookupItemSelect,
        validityChecker: ValidityHelper.emptyValidityChecker,
      },
      {
        fieldName: 'OtherDataCaptureMethod',
        label: 'Other Data Capture Method Description',
        className: 'col-6',
        type: InputTypesEnum.Text,
        // validityChecker: EditServiceDescription.validityCheckerforOtherDataCaptureMethodDescription, // TODO:
        hide: (item) => item.DataCaptureMethodCode != 3,
      },
      {
        fieldName: 'GuidelinesProvided',
        label: 'Guidelines Provided by Client?',
        className: 'col-12',
        type: InputTypesEnum.Bool,
      },
    ],
  },
  {
    label: 'Phone Call Requirements',
    hide: (item) => item.TypeCode != ServiceTypeEnum.InPerson,
    fields: [
      {
        fieldName: 'PrePostPhoneCall',
        label: 'Pre or Post Phone Call',
        className: 'col-12',
        type: InputTypesEnum.Select,
        selectvalues: selectHelper.generateSelectValues(prePostPhoneCallArray.map((p) => p.label)),
      },
      {
        fieldName: 'PhoneCallsRequired',
        label: 'Are Phone Calls required for In-Person Visit',
        className: 'col-12',
        type: InputTypesEnum.Bool,
      },
      {
        fieldName: 'CallFlowDescription',
        label: 'If yes, please explain call flow',
        className: 'col-12',
        type: InputTypesEnum.Text,
        hide: (item) => item.PhoneCallsRequired == 'false' || item.PhoneCallsRequired == '',
      },
      {
        fieldName: 'CallerIdNeeded',
        label: "Does the Client's Phone Have Caller ID?",
        className: 'col-12',
        type: InputTypesEnum.Bool,
      },
      {
        fieldName: 'PhoneCallDescription',
        label: 'Description of Calls',
        className: 'col-12',
        type: InputTypesEnum.TextBox,
      },
      {
        fieldName: 'NumCallsRecorded',
        label: 'No. of Recorded Calls per Evaluation',
        className: 'col-12',
        type: InputTypesEnum.Number,
      },
      {
        fieldName: 'AvgVocazillaCallLength',
        label: 'Avg. Recorded Call Length (min) per Call',
        className: 'col-12',
        type: InputTypesEnum.NumberWithTwoDecimalPlaces,
      },
      {
        fieldName: 'FollowUpPeriodExpected',
        label: 'Wait for Follow-up period expected before/after the call',
        className: 'col-12',
        type: InputTypesEnum.Text,
      },
      {
        fieldName: 'NumCallsNonRecorded',
        label: 'No. of Non-Recorded Calls per Evaluation',
        className: 'col-12',
        type: InputTypesEnum.Number,
      },
      {
        fieldName: 'AvgNonRecordedCallLength',
        label: 'Avg. Non-Recorded Call Length (min) per Call',
        className: 'col-12',
        type: InputTypesEnum.NumberWithTwoDecimalPlaces,
      },
    ],
  },
  {
    label: 'Visit Validation',
    hide: (item) => item.TypeCode != ServiceTypeEnum.InPerson,
    fields: [
      {
        fieldName: 'NumPhotographsReqd',
        label: 'Number of Photographs Required',
        className: 'col-12',
        type: InputTypesEnum.Number,
      },
      {
        fieldName: 'PhotosReqd',
        label: 'Storefront Photo Required?',
        className: 'col-12',
        type: InputTypesEnum.Bool,
      },
      {
        fieldName: 'OtherPhotosDesc',
        label: 'Describe other Photographs Required',
        className: 'col-12',
        type: InputTypesEnum.TextBox,
      },
      {
        fieldName: 'ReceiptReqd',
        label: 'Receipt Required?',
        className: 'col-12',
        type: InputTypesEnum.Bool,
      },
      {
        fieldName: 'SoundRecordingReqd',
        label: 'Sound Recording Required?',
        className: 'col-12',
        type: InputTypesEnum.Bool,
      },
      {
        fieldName: 'VideoRecordingReqd',
        label: 'Video Recording Required?',
        className: 'col-12',
        type: InputTypesEnum.Bool,
      },
      {
        fieldName: 'OtherValidationReqd',
        label: 'Other Validation',
        className: 'col-12',
        type: InputTypesEnum.OtherValidationRequirementLookupItemSelect,
      },
    ],
  },
  {
    label: 'Purchase',
    hide: (item) => item.TypeCode != ServiceTypeEnum.InPerson,
    fields: [
      {
        fieldName: 'PurchaseReqd',
        label: 'Purchase Required?',
        className: 'col-12',
        type: InputTypesEnum.Bool,
      },
      {
        fieldName: 'ReceiptReqd',
        label: 'Receipt Required?',
        className: 'col-12',
        type: InputTypesEnum.Bool,
      },
      {
        fieldName: 'PurchaseAmtCurId',
        label: 'Purchase Amount Currency',
        className: 'col-12',
        type: InputTypesEnum.ActiveCurrencySelect,
      },
      {
        fieldName: 'PurchaseAmt',
        label: 'Minimum Purchase Amount',
        className: 'col-12',
        type: InputTypesEnum.Number,
      },
      {
        fieldName: 'MaxPurchaseAmt',
        label: 'Maximum Purchase Amount',
        className: 'col-12',
        type: InputTypesEnum.Number,
      },
      {
        fieldName: 'PurchaseDesc',
        label: 'Item Required to Be Purchased',
        className: 'col-12',
        type: InputTypesEnum.TextBox,
      },
      {
        fieldName: 'PurchaseReimbursed',
        label: 'Purchase Reimbursed by Client?',
        className: 'col-12',
        type: InputTypesEnum.Bool,
      },
      {
        fieldName: 'PurchaseIncluded',
        label: 'Purchase NOT Reimbursed by BARE or Client?',
        className: 'col-12',
        type: InputTypesEnum.Bool,
      },
      {
        fieldName: 'PurchaseReturned',
        label: 'Required Purchase to be returned by Evaluator as part of their Assignment Scenario?',
        className: 'col-12',
        type: InputTypesEnum.Bool,
      },
    ],
  },
  {
    label: 'Evaluator Demographics',
    hide: (item) => item.TypeCode != ServiceTypeEnum.InPerson,
    fields: [
      {
        fieldName: 'MinAge',
        label: 'Minimum Age',
        className: 'col-12',
        type: InputTypesEnum.Number,
      },
      {
        fieldName: 'MaxAge',
        label: 'Maximum Age',
        className: 'col-12',
        type: InputTypesEnum.Number,
      },
      {
        fieldName: 'GenderCode',
        label: 'Gender',
        className: 'col-12',
        type: InputTypesEnum.CommonGenderLookupItemSelect,
      },
      {
        fieldName: 'MaritalStatusCode',
        label: 'Marital Status',
        className: 'col-12',
        type: InputTypesEnum.CommonMaritalStatusLookupItemSelect,
      },
      {
        fieldName: 'IsChildRequiredForVisit',
        label: 'Child Required for Visit',
        className: 'col-12',
        type: InputTypesEnum.Bool,
      },
      {
        fieldName: 'EvaluationType',
        label: 'Description of additional Demographic Requirements',
        className: 'col-12',
        type: InputTypesEnum.EvaluationTypeLookupItemSelect,
      },
      {
        fieldName: 'OtherQualifications',
        label: 'Other Demographic Requirements',
        className: 'col-12',
        type: InputTypesEnum.TextBox,
      },
    ],
  },
];

export default inPersonPages;
